// extracted by mini-css-extract-plugin
export default {"activityArea":"index_activityArea_a03X3","activityList":"index_activityList_KSOfE"};